module.exports = __webpack_public_path__ + "static/media/success.d7cdeaf2.mp3";